import { render, staticRenderFns } from "./CollectionPerformance.vue?vue&type=template&id=67e64ce7&scoped=true&"
import script from "./CollectionPerformance.vue?vue&type=script&lang=js&"
export * from "./CollectionPerformance.vue?vue&type=script&lang=js&"
import style0 from "./CollectionPerformance.vue?vue&type=style&index=0&id=67e64ce7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e64ce7",
  null
  
)

export default component.exports